export function isModularConfigurationCode(code: string) {
  return /^M-[A-Z0-9]{6}$/i.test(code);
}
